import { createFileRoute } from "@tanstack/react-router";
import { getBlogAuthors } from "@/lib/blogAuthors.functions";
import { DEFAULT_BLOG_AUTHOR, registeredBlogAuthor } from "@/content/blog/authors";
import { BlogByline } from "@/components/article/BlogByline";
import { PublicNav } from "@/components/PublicNav";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/blog/authors")({
  loader: () => getBlogAuthors(),
  head: () => seoHead({ title: "Blog Authors", description: "Meet the people and editorial team behind LeadXkids parent guides, with author biographies and editorial responsibilities.", canonical: "/blog/authors" }),
  component: Authors,
});
function Authors() {
  const authors = Route.useLoaderData();
  return <div className="min-h-dvh bg-background"><PublicNav /><main className="container max-w-3xl mx-auto px-4 py-10">
    <a href="/blog" className="text-sm text-primary underline">Parent Library</a>
    <h1 className="text-3xl font-bold text-foreground mt-5 mb-6">Authors</h1>
    <BlogByline author={DEFAULT_BLOG_AUTHOR} />
    {authors.map((author) => <div id={author.id} key={author.id}><BlogByline author={registeredBlogAuthor(author)} /></div>)}
  </main></div>;
}